import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SmartTableService } from './smart-table.service';
import { OrdersChartService } from './orders-chart.service';
import { OrdersProfitChartService } from './orders-profit-chart.service';
import { PeriodsService } from './periods.service';
import { EmployeesService } from './employees.service';
import { DashboardChartService } from './dashboard-chart.service';
import { GroupsService } from './groups.service';
import { CompanyRestaurantsService } from './company-restaurants.service';
import { MenuTemplatesService } from './menu-templates.service';
import { MenuEtriesService } from './menu-entries.service';
import { CompanyService } from './company.service';

const SERVICES = [
  SmartTableService,
  OrdersChartService,
  OrdersProfitChartService,
  DashboardChartService,
  PeriodsService,
  EmployeesService,
  GroupsService,
  CompanyRestaurantsService,
  CompanyService,
  MenuTemplatesService,
  MenuEtriesService
];

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    ...SERVICES,
  ],
})
export class MockDataModule {
  static forRoot(): ModuleWithProviders<MockDataModule> {
    return {
      ngModule: MockDataModule,
      providers: [
        ...SERVICES,
      ],
    };
  }
}
